import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'

const Tile = styled(Clickable)`
  display: grid;
  grid-template-columns: ${rem(106)} 1fr;
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  min-height: ${rem(108)};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${rem(12)} ${rem(16)};
`

function ExperienceRecentlyViewedSkeletonTile() {
  return <Tile>
    <LoadingBox />
    <Content>
      <TextLoadingBox typography="body-small" width="100%" />
      <div>
        <TextLoadingBox typography="heading6" width={30} />{' '}
        <TextLoadingBox typography="heading6" width={40} />
      </div>
    </Content>
  </Tile>
}

export default React.memo(ExperienceRecentlyViewedSkeletonTile)
